<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.fpaNo')" prop="fpaNo">
                  <!--FPA编号-->
                  <el-input v-model="queryCondition.fpaNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Product" prop="fpaName">
                  <!--FPA名称-->
                  <el-input v-model="queryCondition.fpaName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.agreementLife')" prop="agreementStartDate" class="flexBox">
                  <!--FPA有效期-->
                  <el-date-picker v-model="queryCondition.startDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsStart" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="To" prop="agreementEndDate" class="flexBox">
                  <el-date-picker v-model="queryCondition.endDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsEnd" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Supplier Code" prop="supplierCode">
                    <!--供应商编号-->
                    <el-input v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Supplier Name" prop="supplierAbbreviation">
                    <!--供应商简称-->
                    <el-input v-model="queryCondition.supplierAbbreviation" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Creator" prop="createUser">
                    <!--创建人-->
                    <el-input v-model="queryCondition.createUser" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Status" prop="status">
                    <!--状态-->
                    <ic-select clearable table="TT_FPA" field="QUERY_STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">Search</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">Reset</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'Fold':'Unfold'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-row>
      <div v-if="activeName == 'PQCN'">
        <el-button size="mini" class="btn" type="primary" @click="exportPqcn">Export</el-button>
      </div>
      <div v-if="activeName == 'campaign'">
        <el-button size="mini" class="btn" type="primary" v-acl="FpaLtoCampaignNew" @click="fpaLtoCampaignNew(-99999)">New</el-button>
        <el-button size="mini" class="btn" type="danger" v-acl="FpaLtoCampaignDelete" @click="fpaLtoCampaignDelete()">Delete</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="FpaLtoCampaignRevoke" @click="withdraw">Revoke</el-button>
      </div>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="queryData" class="fpaCa_Tab">
      <el-tab-pane name="campaign" label="Campaign">
        <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='540' @selection-change="handleSelectChange">
          <el-table-column align="center" type="selection" width="55">
          </el-table-column>
          <!--FPA编号-->
          <el-table-column show-overflow-tooltip prop="fpaNo" :label="$t('fpaManage.permanent.fpaNo')" min-width="120px">
            <template slot-scope="scope">
              <div class="a-link" @click="toDetail(scope.row.ttFpaLtoCampaignId)">{{scope.row.fpaNo}}</div>
            </template>
          </el-table-column>
          <!-- FPA名称-->
          <el-table-column show-overflow-tooltip prop="fpaName" label="Product Or Commodity Purchased" min-width="160px"></el-table-column>
          <!--FPA有效期开始-->
          <el-table-column show-overflow-tooltip prop="agreementStartDate" :label="$t('fpaManage.permanent.agreementStartDate')" min-width="120px">
            <template slot-scope="scope">
              {{scope.row.agreementStartDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <!--FPA有效期结束-->
          <el-table-column show-overflow-tooltip prop="agreementEndDate" :label="$t('fpaManage.permanent.agreementEndDate')" min-width="120px">
            <template slot-scope="scope">
              {{scope.row.agreementEndDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <!--供应商简称-->
          <el-table-column show-overflow-tooltip prop="supplierAbbreviation" label="Supplier Name" min-width="200px"></el-table-column>
          <!--状态-->
          <el-table-column show-overflow-tooltip prop="queryStatus" label="Status" min-width="80px"></el-table-column>
          <!--当前审批人-->
          <el-table-column show-overflow-tooltip prop="statusValue" :label="$t('fpaManage.permanent.logicStatus')" min-width="100px"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="PQCN" label="NII">
        <el-table :data="fpaLtoPqcnList" :row-style="changeRowBgColorByIsLocal" max-height="500" ref="fpaLtoPqcnList1" border>
          <el-table-column show-overflow-tooltip align="center" prop="fpaNo" label="FPA No." min-width="120px">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="left" prop="fpaName" label="FPA Name" min-width="170px">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="supplierName" label="Supplier" min-width="300px">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="plantName" label="Facility" min-width="250px">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="Supplied DC" min-width="350px">
            <template slot-scope="scope">{{scope.row.dcs | dcsFilter}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="ingredient" label="Ingredient" min-width="250px">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="localItem" label="Local Item#" min-width="100px">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="Price per CASE(RMB EXCL. VAT)" min-width="250px">
            <el-table-column align="center" prop="purchaseForcast" label="Price" min-width="150px">
              <template slot-scope="scope">{{scope.row.purchaseForcast | thousandSeparator}}</template>
            </el-table-column>
            <el-table-column align="center" prop="unit" label="Unit" min-width="150px">
            </el-table-column>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="vat" label="VAT" min-width="90px">
            <template slot-scope="scope">{{scope.row.vat | ic('TM_MATERIAL_RECORD','URCHASE_TAX_RATE')}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="Price Valid Date" min-width="150px">
            <el-table-column show-overflow-tooltip align="center" prop="priceValidDateFrom" label="From" min-width="150px">
              <!--                                  <template slot-scope="scope">-->
              <!--                                      <el-date-picker v-if="scope.row.isLocal=='1'" type="date" placeholder="选择日期" v-model="scope.row.priceValidDateFrom" value-format="yyyy-MM-dd" style="width: 100%;" disabled></el-date-picker>-->
              <!--                                  </template>-->
              <template slot-scope="scope">{{scope.row.priceValidDateFrom|dateFormatFilter}}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="priceValidDateTo" label="to" min-width="150px">
              <template slot-scope="scope">{{scope.row.priceValidDateTo|dateFormatFilter}}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="tradeTerm" label="Trade Term" min-width="250px">
            <template slot-scope="scope">{{scope.row.tradeTerm | ic('TM_MATERIAL_RECORD','PRICE_TYPE')}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="totalEstimatedQty" label="Total Estimated Qty(Case)" min-width="200px">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="totalEstimatedAmount" label="Total Estimated Amount (RMB)" min-width="250px">
            <template slot-scope="scope">{{scope.row.totalEstimatedAmount | fix(2) | thousandSeparator}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="transportaionMethod" label="Delivery Type" min-width="150px">
            <template slot-scope="scope">{{scope.row.transportaionMethod | ic('TM_MATERIAL','DIS_TYPE')}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="freight" label="Freight" min-width="150px">
            <template slot-scope="scope">{{scope.row.freight | thousandSeparator}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="totalCost" label="Total Cost(without VAT)" min-width="250px">
            <template slot-scope="scope">{{scope.row.totalCost  | thousandSeparator}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="Promotion Date From" min-width="200">
            <template slot-scope="scope">{{scope.row.promotionDateFrom|dateFormatFilter}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="Promotion Date To" min-width="200">
            <template slot-scope="scope">{{scope.row.promotionDateTo|dateFormatFilter}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="remark" label="Remark" min-width="250px"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import fpaLtoCampaignApi from "@/api/fpa/fpaLtoCampaign";
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";
import commonFunction from "@/utils/dataTableUtils";
import store from '@/store/index'
import paginationMixin from '@/mixins/pagitionMixin';
export default {
  components: { IcSelect },
  name: "fpaLtoCampaignList",
  mixins: [paginationMixin],
  filters: {
    dcsFilter(dcIdsStr) {
      if (commonFun.isEmpty(dcIdsStr)) {
        return "";
      } else {
        const split = dcIdsStr.split(",");
        let dcNames = [];
        split.forEach(id => {
          let dc = commonFun.getICVal("BASE", "DC", id);
          dcNames.push(dc);
        })
        return dcNames.join(",")
      }
    }
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      activeName: "campaign",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        supplierCode: '',
        supplierAbbreviation: '',
        materialNo: '',
        createUser: '',
        status: '',
      },
      selectRow: [],
      tableList: [],
      fpaLtoPqcnList: [],
      totalCount: null,
      AgreementPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      AgreementPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    // this.queryData();
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    fpaLtoCampaignApi.fpaLtoCampaignList('', to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        if (vm.activeName == 'campaign') {
          vm.tableList = res.resultData;
        } else {
          vm.fpaLtoPqcnList = res.resultData;
        }
        vm.totalCount = res.totalCount;
      })
    })
  },
  methods: {
    withdraw() {
      let that = this;
      if (that.selectRow.length == 0) {
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToWithdraw'))
        return false;
      }
      let rows = that.selectRow;
      let checkData = false;
      for (let index in rows) {
        let rowData = rows[index];
        if (['new'].indexOf(rowData.status) >= 0) {
          checkData = true;
        }
      }
      if (checkData) {
        this.$message.error(this.$t('fpaManage.permanent.checkWithdraw'))
        return false;
      } else {
        that.$confirm('Would you like to withdraw the selected record?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: 'colorBtn',
          cancelButtonClass: 'btn_custom_cancel',
          type: 'warning'
        }).then(() => {
          let ttFpaIdArr = rows.map(row => row.ttFpaLtoCampaignId);
          fpaLtoCampaignApi.fpaWithdraw(ttFpaIdArr).then((res) => {
            if (res.code == '200') {
              this.activeName = 'campaign';
              this.queryData();
              this.selectRow = [];
            } else {
              this.$message.error(this.$t(res.msg) || 'Operate error')
            }
          });
        })
      }
    },
    exportPqcn() {
      fpaLtoCampaignApi.exportPqcn(this.queryCondition);
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      fpaLtoCampaignApi.fpaLtoCampaignList(this.activeName, this.queryCondition).then(res => {
        if (this.activeName == 'campaign') {
          this.tableList = res.resultData;
        } else {
          this.fpaLtoPqcnList = res.resultData;
        }
        this.totalCount = res.totalCount;
      });
    },
    //选择操作
    handleSelectChange: function (row) {
      this.selectRow = row;
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        supplierCode: '',
        supplierAbbreviation: '',
        materialNo: '',
        createUser: '',
        status: '',
      }
      this.queryData();
    },
    changeRowBgColorByIsLocal({ row, rowIndex }) {
      let stylejson = {};
      if (row.isLocal === '0') {
        stylejson.background = '#17b6e5';
      }
      return stylejson;
    },
    fpaLtoCampaignDelete() {
      let that = this;
      if (that.selectRow.length == 0) {
        //请选择需要删除的记录！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        return false;
      }
      let rows = that.selectRow;
      let checkData = false;
      for (let index in rows) {
        let rowData = rows[index];
        if (rowData.status != 'new' && rowData.status != 'reject') {
          checkData = true;
        }
      }
      if (checkData) {
        //仅新建/审批退回状态下数据可删除！
        this.$message.error(this.$t('fpaManage.permanent.checkDelete'))
        return false;
      } else {
        //您确定要删除所选记录吗？
        that.$confirm('Are you sure to delete these records?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: 'colorBtn',
          cancelButtonClass: 'btn_custom_cancel',
          type: 'warning'
        }).then(() => {
          let ttFpaLtoCampaginIdArr = rows.map(row => row.ttFpaLtoCampaignId);
          let statusArr = rows.map(row => row.status);

          let param = {
            ttFpaLtoCampaginIdArr: ttFpaLtoCampaginIdArr + '',
            statusArr: statusArr + '',
          }
          fpaLtoCampaignApi.fpaLtoCampaignDelete(param).then((res) => {
            if (res.code == '200') {
              this.activeName = 'campaign';
              this.queryData();
              this.selectRow = [];
            } else {
              this.$message.error(this.$t(res.msg) || this.$t("common.operateError"))
            }
          });
        })

      }
    },
    fpaLtoCampaignNew() {
      this.toDetail('-1');
    },
    toDetail(ttFpaLtoCampaignId) {
      this.$router.push({ name: 'fpaLtoCampaignDetail', params: { ttFpaLtoCampaignId: ttFpaLtoCampaignId } });
      // this.$router.push({ name: 'newCampaign', params: { ttFpaLtoCampaignId: ttFpaLtoCampaignId } });
    },
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.supplierCodeDialog .email.el-form-item .el-form-item__content {
  display: flex;
}
</style>
